// utils/access.ts
import { EmployeeDetails } from "../../../Types/UserProfileDetails";
import { IUser } from "../../login/types";
import { ADMIN_HR_ROLES, PRIVILEGED_IDS } from "./constant";

const norm = (v?: string | null) => (v ?? "").trim().toLowerCase();

export const isAdminOrHR = (employeeType?: string): boolean =>
  ADMIN_HR_ROLES.includes(norm(employeeType) as any);

export const isPrivilegedEmployee = (employeeId?: number): boolean =>
  employeeId ? PRIVILEGED_IDS.includes(employeeId as any) : false;

export const canEmployeeViewInfo = (
  profile: EmployeeDetails,
  loggedInEmployee: IUser,
  roleType: string
): boolean => {
  if (!profile || !loggedInEmployee) return false;

  const loggedInId = Number(loggedInEmployee.id);
  const managerIds = [
    ...(profile.managerDetails ?? []),
    ...(profile.additionalManagerDetails ?? []),
  ].map(({ id }) => Number(id));

  const isTeamManager =
    norm(roleType) === "manager" && managerIds.includes(loggedInId);

  return (
    isAdminOrHR(roleType) ||
    norm(roleType) === "account" ||
    isTeamManager ||
    loggedInId === Number(profile.jobInformation?.userId)
  );
};

export const canShowEditInfo = (
  employeeProfileDetails: EmployeeDetails,
  loggedInEmployee: IUser
): boolean => {
  const isSameId =
    Number(employeeProfileDetails?.jobInformation?.userId) ===
    Number(loggedInEmployee?.id);

  return (
    (Boolean(employeeProfileDetails?.editOption) && isSameId) ||
    (isAdminOrHR(loggedInEmployee?.user_type) && !isSameId) ||
    PRIVILEGED_IDS.includes(loggedInEmployee?.id as any)
  );
};

export const hasAccessPrivateFields = (
  employeeId: number,
  loggedInUserId: number,
  loggedInUserType: string
): boolean => {
  const role = norm(loggedInUserType);
  return (
    isPrivilegedEmployee(employeeId) ||
    isPrivilegedEmployee(loggedInUserId) ||
    ["admin", "hr", "account"].includes(role) ||
    Number(employeeId) === Number(loggedInUserId)
  );
};
